import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import { SearchInput } from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchInput';
import { SearchTags } from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchTags';
import { useSearchTerm } from 'sections/Resources/FreightDictionary/hooks/useSearchTerm';
import styles from 'sections/Resources/FreightDictionary/components/SectionTerms/SearchPanel/SearchPanel.module.scss';

const cn = classNames.bind(styles);

const SearchPanel = (): ReactElement => {
  const { setSearchValue, isSearchActive, setIsSearchActive } = useSearchTerm();

  return (
    <div className={cn('search-panel')}>
      <SearchTags/>
      <SearchInput
        name="term"
        placeholder="Search for freight terms"
        setSearchValue={setSearchValue}
        isSearchActive={isSearchActive}
        setIsSearchActive={setIsSearchActive}
      />
    </div>
  );
};

export { SearchPanel };